import { useTranslation } from "react-i18next";
import ArrowButton from "./ArrowButton";
import "./OnPremToCloudScreen.scss";
import image from "./images/on-prem-to-cloud-image.jpg";

function OnPremToCloudScreen() {
  const { t, i18n } = useTranslation();
  return (
    <div className="on-prem-to-cloud-screen-container">
      <div className="mobile-hero">
        <img src={image} alt="woman wearing headphone" />
      </div>
      <div className="on-prem-to-cloud-screen-white-gradient">
        <div className="image-container"></div>
        <div className="container on-prem-to-cloud-screen-text-container ">
          <div className="text-container-left">
            <h1 className="blue-header">
              <div
                dangerouslySetInnerHTML={{
                  __html: t("OnPremToCloud.title_html", {
                    interpolation: { escapeValue: false },
                  }),
                }}
              />
            </h1>
            <p>{t("OnPremToCloud.first-paragraph")}</p>
            <p>{t("OnPremToCloud.second-paragraph")}</p>
            <div className={"arrow-buttons-container-left"}>
              <ArrowButton to="/add-innovation" side="left"></ArrowButton>
              <ArrowButton
                to="/deeper-relationships"
                side="right"
              ></ArrowButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnPremToCloudScreen;
